import React, { useState, useEffect } from 'react';
import './Faq.css';
import mainPic from '../../../../images/faq/PEWI-103 1.webp';
import FaqCard from '../../../../components/main/cards/FaqCard/FaqCard';
import * as faqsAPI from '../../../../api/services/faqsApi';

export default function Faq() {
  const [faqs, setFaqs] = useState();

  useEffect(() => {
    //GET LIST OF ALL FAQS
    async function getAllFaqs() {
      try {
        let faqsList = await faqsAPI.getFaqs();
        setFaqs(faqsList);
      } catch (err) {
        console.log(err);
      }
    }

    getAllFaqs();
  }, []);

  return (
    <div className='faq-container'>
      <img id='faq-main-image' src={mainPic} alt='pro-evolution-wellness-faq' />
      <div id='faq-info-container'>
        <div id='faq-title'>FREQUENTLY ASKED QUESTIONS</div>
        {faqs &&
          faqs.map((f) => (
            <FaqCard quest={f.question} ans={f.answer} key={f._id} />
          ))}
      </div>
    </div>
  );
}
